import { OtpResendPayload, OtpResendResponse } from '@repo/user-types'
import { AxiosInstance, AxiosResponse } from 'axios'

export const otpResend = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: OtpResendPayload
}): Promise<AxiosResponse<OtpResendResponse>> => {
  const { challengeId, ...rest } = params

  return api.post<OtpResendResponse>(`/notifications/otp/${challengeId}/resend`, rest)
}
